import { moveToFulfilled } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import {
  UserFollowedLeadersListLoadAction,
  UserFollowedLeadersListLoadMoreAction,
} from '../../domains/leadersManagement/actions.types';

import { UserFollowedLeaders } from './types';

export type UserFollowedLeadersAction = UserFollowedLeadersListLoadAction | UserFollowedLeadersListLoadMoreAction;

const initialState: UserFollowedLeaders = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const reducer: Reducer<UserFollowedLeaders, UserFollowedLeadersAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'FOLLOWED_LEADERS.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.userFollowedLeaders);
    case 'FOLLOWED_LEADERS.LOAD_MORE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.userFollowedLeaders);
    default:
      return state;
  }
};

export default reducer;
